import 'animate.css';

let index = 0;

const effects = ['flash', 'wobble', 'rubberBand', 'shake'];

function animate(id) {
  const element = document.getElementById(id);
  if (!element) {
    return;
  }
  const duration = 1000;
  const style = effects[index];
  index = (index + 1) % effects.length;
  element.classList.add('animated', style);
  window.setTimeout(() => {
    element.classList.remove('animated', style);
  }, duration);
}

export default animate;
